import { ISwrResponse } from 'lib/hooks';
import { ISession } from 'lib/types/session';
import { createContext, useContext } from 'react';
import { PermissionName } from './types';

interface IAuthContext {
  getIsFeatureEnabled: (featureName: string) => boolean;
  getIsInPermission: (allowed: PermissionName) => boolean;
  getIsPageAccessible: (pageName: string) => boolean;
  isInternalAdmin: boolean;
  session: ISession;
  refreshSession: ISwrResponse<ISession>['mutate'];
}

export const AuthContext = createContext<IAuthContext>({
  getIsFeatureEnabled: () => false,
  getIsInPermission: () => false,
  getIsPageAccessible: () => false,
  isInternalAdmin: false,
  session: undefined,
  refreshSession: undefined,
});

export const useAuthContext = () => useContext(AuthContext);
